<app-cache-debug-badge />
<div class="bg-[#F4F7FC] flex flex-col min-h-screen">
  <div class="flex flex-grow justify-center items-center">
    <p-card styleClass="!border !border-[#dde1e6] !shadow-none !p-0">
      <div class="w-[350px] xlplus:w-[400px] h-auto xlplus:h-auto">
        <div class="flex justify-center items-center gap-2 mt-[12px]">
          <div class="w-[50px] h-[45px] xlplus:w-[70px] xlplus:h-[65px] relative">
            <img
              ngSrc="/common/yyc_logo.webp"
              alt="YYC Logo"
              priority
              fill
              (load)="isLoadingYYCLogo = false"
              [style.visibility]="isLoadingYYCLogo ? 'hidden' : 'visible'"
            />
            @if (isLoadingYYCLogo) {
            <p-skeleton
              styleClass="!absolute !inset-0 !w-full !h-full "
              shape="rectangle"
            />
            }
          </div>
          <p
            class="font-inter font-extrabold text-15[px] xlplus:text-[20px] ml-1 my-auto"
          >
            <span class="mr-1 text-taxpod-blue">MBRS</span>TOOL
          </p>
        </div>
        <router-outlet></router-outlet>
      </div>
    </p-card>
  </div>
     <footer
    class="h-[62px] p-6 flex justify-center items-center text-[12px] xlplus:text-[12px] text-gray-400 font-lato"
      >
      Copyright © {{ currentYear }} YYC Holdings Sdn. Bhd.
   </footer>
   <!-- <footer class="mt-auto">
  <p
    class="w-[1392px] max-w-full mx-auto h-[14px]
           font-lato font-normal text-[12px] leading-[100%]
           text-center">
    Copyright © {{ currentYear }} YYC Holdings Sdn. Bhd.
  </p>
</footer> -->

</div>



